// const baseURL = "http://localhost:4000"
const baseURL = "https://vaxin8d-orc.herokuapp.com"


export default baseURL